import { render, staticRenderFns } from "./LessonplanResource.vue?vue&type=template&id=22bce66a"
import script from "./LessonplanResource.vue?vue&type=script&lang=js"
export * from "./LessonplanResource.vue?vue&type=script&lang=js"
import style0 from "./LessonplanResource.vue?vue&type=style&index=0&id=22bce66a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports